import angular from 'angular'
import coreModule from '../core'
import loginComponent from './login.component'
import loginRouteConfigBlock from './login.route'

export default angular
  .module('app.login', [coreModule])
  .config(loginRouteConfigBlock)
  .component('elLogin', loginComponent)
